import { Stack } from "@mui/material";
import { BodyTextM, HeadingL } from "@repo/ui";
import { useFormikContext } from "formik";
import { type FC } from "react";
import { dateTimeFormat } from "../../../functions/dates";
import AddressTemplate from "../../AddressBox/AddressTemplate";
import InformationList from "../../InformationList";
import { type BeneficiariesChangeFormFormValues } from "../BeneficiariesChangeForm";

const ChangesOverview: FC = () => {
    const { values } = useFormikContext<BeneficiariesChangeFormFormValues>();
    const hasBeneficiaries = values.beneficiaries.length > 0;

    if (hasBeneficiaries) {
        return (
            <>
                <HeadingL withoutScale data-test="changes-overview-header">
                    Přehled změn
                </HeadingL>
                <Stack spacing={5}>
                    {values.beneficiaries.map((item, index) => {
                        return (
                            <InformationList
                                data-test="changes-information-list"
                                title={`${String(index + 1)}. člověk`}
                                key={`${String(index + 1)}. člověk`}
                                information={[
                                    {
                                        title: "Jméno",
                                        description: item.firstName ?? "",
                                    },
                                    {
                                        title: "Příjmení",
                                        description: item.lastName ?? "",
                                    },
                                    {
                                        title: "Datum narození",
                                        description: dateTimeFormat.format(item.dateOfBirth ?? undefined),
                                    },
                                    {
                                        title: "Podíl",
                                        description: `${String(values.ratios[index].ratio)} %`,
                                    },
                                    {
                                        title: "Kontaktní adresa",
                                        description: <AddressTemplate address={item.address} />,
                                    },
                                ]}
                            />
                        );
                    })}
                </Stack>
            </>
        );
    }
    return (
        <>
            <HeadingL withoutScale>Přehled změn</HeadingL>
            <BodyTextM>Všichni lidé byli odstraněni.</BodyTextM>
        </>
    );
};

export default ChangesOverview;
